<template>
	<div v-loading="loading" class="main-content">
		<div class="main-content-inner">
			<div v-if="!loading" class="container-fluid">
				<div class="row">
					<div class="col-lg-12">
						<div class="content margin-bottom-30">
							<div class="content-header">
								<h2>
									Application details
								</h2>
							</div>
							<div class="content-body">
								<div v-if="applicationData.created_at" class="row middle client-row">
									<div class="col-lg-2 col-sm-12">
										<span class="client-label">Application date</span>
									</div>
									<div class="col-lg-6 col-sm-12">
										{{ applicationData.created_at | convertDate }}
									</div>
								</div>
								<div v-if="applicationData.loan_amount" class="row middle client-row">
									<div class="col-lg-2 col-sm-12">
										<span class="client-label">Loan amount</span>
									</div>
									<div class="col-lg-6 col-sm-12">
										{{ applicationData.loan_amount | convertCurrency }}
									</div>
								</div>
								<div v-if="applicationData.credit_loan_amount" class="row middle client-row">
									<div class="col-lg-2 col-sm-12">
										<span class="client-label">Credit loan amount</span>
									</div>
									<div class="col-lg-6 col-sm-12">
										{{ applicationData.credit_loan_amount | convertCurrency }}
									</div>
								</div>
								<div v-if="applicationData.tenure" class="row middle client-row">
									<div class="col-lg-2 col-sm-12">
										<span class="client-label">Loan duration</span>
									</div>
									<div class="col-lg-6 col-sm-12">
										{{ applicationData.tenure }} {{ applicationData.tenure === 1 ? 'year' : 'years' }}
									</div>
								</div>
								<div v-if="applicationData.tenure" class="row middle client-row">
									<div class="col-lg-2 col-sm-12">
										<span class="client-label">Application status</span>
									</div>
									<div class="col-lg-6 col-sm-12">
										<span class="text-uppercase">{{ applicationData.status }}</span>
									</div>
								</div>
								<div class="row middle client-row">
									<div class="col-lg-2 col-sm-12">
										<span class="client-label">
											<br />
										</span>
									</div>
								</div>
								<div class="row middle client-row">
									<div class="col-lg-2 col-sm-12">
										<span class="client-label">Applicant name</span>
									</div>
									<div class="col-lg-6 col-sm-12">
										{{ applicationData.first_name }} {{ applicationData.last_name }}
									</div>
								</div>
								<div class="row middle client-row">
									<div class="col-lg-2 col-sm-12">
										<span class="client-label">Applicant email</span>
									</div>
									<div class="col-lg-6 col-sm-12">
										{{ applicationData.email }}
									</div>
								</div>
								<div class="row middle client-row">
									<div class="col-lg-2 col-sm-12">
										<span class="client-label">Applicant phone</span>
									</div>
									<div class="col-lg-6 col-sm-12">
										{{ applicationData.phone_number }}
									</div>
								</div>
								<div v-if="applicationData.co_applicant">
									<div class="row middle client-row">
										<div class="col-lg-2 col-sm-12">
											<span class="client-label">
												<br />
											</span>
										</div>
									</div>
									<div class="row middle client-row">
										<div class="col-lg-2 col-sm-12">
											<span class="client-label">Co-applicant email</span>
										</div>
										<div class="col-lg-6 col-sm-12">
											{{ applicationData.co_applicant_email }}
										</div>
									</div>
									<div class="row middle client-row">
										<div class="col-lg-2 col-sm-12">
											<span class="client-label">Co-applicant phone</span>
										</div>
										<div class="col-lg-6 col-sm-12">
											{{ applicationData.co_applicant_phone_number }}
										</div>
									</div>
								</div>
							</div>
							<div class="content-footer">
								<router-link to="/applications">
									<i class="el-icon-back"></i> Back to applications
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { HTTP } from '@/services/api'

export default {
	name: 'ApplicationView',
	metaInfo () {
		return {
			title: 'Application View',
		}
	},
	data () {
        return {
			loading: true,
			applicationData: null,
        }
    },
	mounted () {
		this.loadData()
	},
	methods: {
		loadData () {
			HTTP({
				method: 'GET',
				url: '/loan-applications/' + this.$route.params.id,
				crossdomain: true
			})
			.then(response => {
				this.applicationData = response.data
				this.loading = false
			})
			.catch(error => {
				this.loading = false
				this.$notify({
					title: 'Error',
					message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
					type: 'error',
					position: 'bottom-right',
					duration: 3500
				})
			})
		},
		handleCancel () {
			this.$router.push('/applications')
		}
	}
}
</script>
